import limitdecimal from "./limitdecimal";

// 自定义指令
const directives = {
  limitdecimal
};

export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key]);
    });
  }
};
